'use client';

import { Wizard } from '@/components/wizard/Wizard';

import { AddConnectorCreationFlow } from './AddConnectorCreationFlow';
import {
  defaultAddConnectorWizardState,
  type AddConnectorWizardState,
} from './addConnectorWizardState';

interface AddConnectorWizardPanelProps {
  workspaceId: string;
  onAbort: () => void;
  onCreated: () => void;
}

export function AddConnectorWizardPanel({
  workspaceId,
  onAbort,
  onCreated,
}: AddConnectorWizardPanelProps) {
  return (
    <Wizard<AddConnectorWizardState>
      onAbort={onAbort}
      hideBackArrow={true}
      onFinish={async () => {
        onCreated();
        return true;
      }}
      flow={[AddConnectorCreationFlow]}
      initialState={{ ...defaultAddConnectorWizardState, workspaceId }}
      title='Add Connector'
      stepperLabels={[]}
    />
  );
}
